import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

const Content = styled(motion.div)`
  background: white;
  border-radius: var(--border-radius-lg);
  padding: 3rem;
  text-align: center;
  box-shadow: var(--shadow-xl);
  max-width: 600px;
  width: 100%;
`;

const Logo = styled.div`
  font-size: 4rem;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  color: var(--gray-800);
  margin-bottom: 1rem;
  font-size: 2.5rem;
`;

const Subtitle = styled.p`
  color: var(--gray-600);
  font-size: 1.25rem;
  margin-bottom: 2rem;
`;

const FeatureList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
`;

const Feature = styled.div`
  text-align: center;
  
  .icon {
    font-size: 2rem;
    color: var(--primary-color);
    margin-bottom: 0.5rem;
  }
  
  h3 {
    font-size: 1rem;
    color: var(--gray-800);
    margin-bottom: 0.5rem;
  }
  
  p {
    font-size: 0.875rem;
    color: var(--gray-600);
    margin: 0;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled.button`
  padding: 1rem 2rem;
  border-radius: var(--border-radius);
  font-weight: 600;
  font-size: 1rem;
  transition: var(--transition);
  
  &.primary {
    background: var(--primary-color);
    color: white;
    
    &:hover {
      background: var(--primary-dark);
      transform: translateY(-2px);
    }
  }
  
  &.secondary {
    background: transparent;
    color: var(--primary-color);
    border: 2px solid var(--primary-color);
    
    &:hover {
      background: var(--primary-color);
      color: white;
    }
  }
`;

const Home = () => {
  const handleWhatsAppClick = () => {
    // Link para WhatsApp (em produção seria o número real)
    window.open('https://wa.me/5511999999999?text=Olá! Gostaria de saber mais sobre o Magzy.', '_blank');
  };

  return (
    <Container>
      <Content
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <Logo>✂️</Logo>
        <Title>Magzy</Title>
        <Subtitle>Gestão completa para o seu salão ou estúdio</Subtitle>

        <FeatureList>
          <Feature>
            <div className="icon">📅</div>
            <h3>Agenda inteligente</h3>
            <p>Visualize e gerencie seus agendamentos como um calendário</p>
          </Feature>

          <Feature>
            <div className="icon">💰</div>
            <h3>Controle financeiro</h3>
            <p>Acompanhe receitas, pagamentos e relatórios do mês</p>
          </Feature>

          <Feature>
            <div className="icon">🤖</div>
            <h3>IA assistente</h3>
            <p>Responde clientes no WhatsApp automaticamente</p>
          </Feature>
        </FeatureList>

        <ButtonGroup>
          <Button className="primary" onClick={() => window.location.href = '/entrar'}>
            Começar agora
          </Button>

          <Button className="secondary" onClick={handleWhatsAppClick}>
            <i className="fab fa-whatsapp" style={{ marginRight: '0.5rem' }} />
            Falar com a gente
          </Button>
        </ButtonGroup>
      </Content>
    </Container>
  );
};

export default Home; 